import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { filter, tap } from 'rxjs/operators';

import { UploadQueueService } from '@services/upload/upload-queue.service';
import { JobMediaFacade } from '@app/facades/job-media.facade';
import { JobIncidentMediaFacade } from '@app/facades/job-incident-media.facade';
import { JobRestorationMediaFacade } from '@app/facades/job-restoration-media.facade';

import { appResume } from '../app-state/app-state.actions';
import { uploadStateChanged } from './upload-queue.actions';

@Injectable()
export class UploadQueueEffects {
  /**
   * Progress only streams while foregrounded, so after any background stint
   * the WebView's view of the queue is stale by definition. Native is the
   * source of truth; re-read it.
   */
  syncOnResume$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(appResume),
        tap(() =>
          this.uploads
            .sync()
            .catch(err => console.log('upload queue resync failed', err))
        )
      ),
    { dispatch: false }
  );

  /**
   * When an upload completes, the server now holds the real image. Re-fetch
   * the entity so its S3 thumbnail replaces the local pending one.
   *
   * `load(key)` is the auto-entity facade method that issues the GET. Its
   * `selectByKey` only moves the selection pointer in the store and never
   * touches the network, so it would leave the stale entity in place.
   */
  refetchOnDone$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(uploadStateChanged),
        filter(action => action.state === 'done'),
        tap(action => {
          switch (action.entityType) {
            case 'JobMedia':
              this.jobMedia.load(action.entityId);
              break;
            case 'JobIncidentMedia':
              this.incidentMedia.load(action.entityId);
              break;
            case 'JobRestorationMedia':
              this.restorationMedia.load(action.entityId);
              break;
          }
        })
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private uploads: UploadQueueService,
    private jobMedia: JobMediaFacade,
    private incidentMedia: JobIncidentMediaFacade,
    private restorationMedia: JobRestorationMediaFacade
  ) {}
}
